/* DON'T EDIT THIS FILE: edit original and run build again */ import { ColorScheme, colorSchemeProperties } from "./color-scheme-type.ts";

export const tenantColors: ColorScheme = {};

export const applyTenantColors = (tenantColorsOptions: ColorScheme): void => {
  colorSchemeProperties.forEach((colorKey) => {
    const value = tenantColorsOptions[colorKey];
    if (value) {
      tenantColors[colorKey] = value;
      addColor(colorKey, value);
    }
  });
};
const addColor = (colorKey: string, value: string) => {
  document.body.style.setProperty(`--tenant-${colorKey}`, value);
};
